import { render } from "./OverlayLoader.vue?vue&type=template&id=913e1168"
import script from "./OverlayLoader.vue?vue&type=script&lang=js"
export * from "./OverlayLoader.vue?vue&type=script&lang=js"

import "./OverlayLoader.vue?vue&type=style&index=0&id=913e1168&lang=scss"

import exportComponent from "/Users/alizand/Herd/rodeo/base-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__